// @ts-ignore
import HubspotForm from "react-hubspot-form"
import { useTranslation } from "react-i18next";

interface EnterpriseContactUsProps {
    title?: string;
    isEnterprise?: boolean;
}

const EnterpriseContactUs: React.FC<EnterpriseContactUsProps> = (props) => {
    const COMPONENT_CLASS = 'c-enterprise-contact';
    const params = new URLSearchParams(window.location.search);
    const downgrade = params.get("downgrade");
    const upgrade = params.get("upgrade");
    const { t } = useTranslation();

    let hubspotFormId = 'bc6e2ab1-7e18-4ec3-a4d0-c3092ec2f090';

    if (upgrade) {
        hubspotFormId = 'bca42e59-3dbb-45e9-9856-eee812caffe8';
    }
    if (props.isEnterprise || downgrade) {
        hubspotFormId = '4943c31c-82ab-4d53-aaaa-58867cb264d1';
    }

    return (
        <div className={`${COMPONENT_CLASS}`}>
            {props.title
                ?
                <h3 className={`c-subscription-dialog-box__header`} style={{ marginBottom: '1rem' }}>
                    {props.title}
                </h3>
                :
                <h3 className={`c-subscription-dialog-box__headert`} style={{ marginBottom: '1rem', fontSize: '2.25rem', fontWeight: '300', lineHeight: '1.5rem', textAlign: 'center' }}>
                    {t('pricing.plansPage.upgradingToEnterprise')}
                </h3>
            }

            <div className={`${COMPONENT_CLASS}__form-container`}>
                <p>
                    {t('pricing.plansPage.fillInfo')}
                </p>

                <div className={`${COMPONENT_CLASS}__form`}>
                    <HubspotForm
                        portalId='5419630'
                        formId={hubspotFormId}
                        loading={<div>{t('misc.loading')}</div>}
                    />
                </div>
            </div>
        </div>
    );
}

export default EnterpriseContactUs